import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { BTRouteTypeInsertRequest } from "./BTRouteTypeInsertRequest";
import { BTRouteTypeUpdateRequest } from "./BTRouteTypeUpdateRequest";

@Injectable()
export class DataService_BusTrackerRouteType {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	RouteTypeSelectAll() {
		var postResult$ = new Subject();
		var url = "BusTracker/RouteTypeSelectAll?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RouteTypeInsert(parms: BTRouteTypeInsertRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/RouteTypeInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RouteTypeUpdate(parms: BTRouteTypeUpdateRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/RouteTypeUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RouteTypeToggle(BusRouteTypeID, Active) {
		var postResult$ = new Subject();
		var url = "BusTracker/RouteTypeToggle?BusRouteTypeID=" + BusRouteTypeID + "&Active=" + Active;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RouteTypeInUse(BusRouteTypeID) {
		var postResult$ = new Subject();
		var url = "BusTracker/RouteTypeInUse?BusRouteTypeID=" + BusRouteTypeID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RouteTypeDelete(BusRouteTypeID) {
		var postResult$ = new Subject();
		var url = "BusTracker/RouteTypeDelete?BusRouteTypeID=" + BusRouteTypeID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ImportPreferenceSelect() {
		var postResult$ = new Subject();
		var url = "BusTracker/ImportPreferenceSelect?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
